import React from 'react';
import PropTypes from 'prop-types';

import { Text, Title } from 'elements';
import ContactListSection from './ContactList';
import { ContactSectionStyled, ContentWrapper } from './styled';
import { ContentSection } from 'components';
import { CONTACT_SECTION } from 'constants/contentful';

const ContactSection = ({ contentBlock, title, body }) => {
  return (
    <ContactSectionStyled key={CONTACT_SECTION}>
      <ContentSection>
        <ContentWrapper>
          <Title content={title} modifiers='secondarySmall' as='h3' />
          <Text content={body} />
        </ContentWrapper>
        <ContactListSection contentBlock={contentBlock} />
      </ContentSection>
    </ContactSectionStyled>
  );
};

ContactSection.propTypes = {
  title: PropTypes.string,
  body: PropTypes.string,
  contentBlock: PropTypes.object,
};

export default ContactSection;
